import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';

import type {
  SaudeAlertasResponse,
  SaudeConfigResponse,
  SaudeOverviewResponse,
  UpdateSaudeConfigInput,
} from '../../types/saudeIntegracoes';

export const saudeIntegracoesService = {
  getOverview: async (): Promise<SaudeOverviewResponse> => {
    const response = await apiGet('/admin/integracoes/saude');
    return parseApiResponse<SaudeOverviewResponse>(response);
  },

  getAlertas: async (): Promise<SaudeAlertasResponse> => {
    const response = await apiGet('/admin/integracoes/saude/alertas');
    return parseApiResponse<SaudeAlertasResponse>(response);
  },

  refresh: async (): Promise<SaudeOverviewResponse> => {
    const response = await apiPost('/admin/integracoes/saude/refresh', {});
    return parseApiResponse<SaudeOverviewResponse>(response);
  },

  getConfig: async (): Promise<SaudeConfigResponse> => {
    const response = await apiGet('/admin/integracoes/config');
    return parseApiResponse<SaudeConfigResponse>(response);
  },

  updateConfig: async (input: UpdateSaudeConfigInput): Promise<{ atualizados: number }> => {
    const response = await apiPut('/admin/integracoes/config', input);
    return parseApiResponse<{ atualizados: number }>(response);
  },
};
